(() => {
  function initializeHome() {
    const root = document.querySelector('#ormee-260531-top.ormee-home-v2');
    if (!root || root.dataset.homeInitialized) return;
    root.dataset.homeInitialized = 'true';
    const categories = root.querySelectorAll('.faq-category');
    const lists = root.querySelectorAll('.faq-list');
    categories.forEach(button => button.addEventListener('click', () => {
      categories.forEach(category => {
        const selected = category === button;
        category.classList.toggle('active', selected);
        category.setAttribute('aria-pressed', String(selected));
      });
      lists.forEach(list => list.classList.toggle('hidden', list.dataset.category !== button.dataset.category));
    }));
    root.querySelectorAll('.faq-item').forEach((item, index) => {
      const question = item.querySelector('.faq-question');
      const answer = item.querySelector('.faq-answer');
      if (!question || !answer) return;
      answer.id = `ormee-home-answer-${index}`;
      question.setAttribute('aria-controls', answer.id);
      question.addEventListener('click', () => {
        const expanded = question.getAttribute('aria-expanded') !== 'true';
        question.setAttribute('aria-expanded', String(expanded));
        answer.style.display = expanded ? 'flex' : 'none';
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeHome, { once: true });
  else initializeHome();
  document.addEventListener('shopify:section:load', initializeHome);
})();
